import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("${process.env.PUBLIC_URL}/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("${process.env.PUBLIC_URL}/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #18216d;
        font-size: 3em;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #18216d;
        font-size: 1.5em;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .ant-steps-item-active .ant-steps-item-icon {
        background-color: #2E186A !important;
        border-color: #2E186A !important;
    }
    .ant-steps-item-finish .ant-steps-item-icon {
        border-color: #2E186A !important;
        color: #2E186A !important;
    }
    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
        background-color: #2E186A !important;
    }
    .ant-steps-finish-icon {
        fill: #2E186A !important;
        color: #2E186A !important;
    }
    .ant-input {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 0.5rem 1rem;
        
    }
    .ant-form-item-label {
        text-align: left !important;
    }
    .ant-form-item-row {
        display: flex;
        flex-direction: column;
        
        label {
            margin-bottom: 0.5rem;
            text-align: left !important;
            font-size: 14px;
            color: #18216d;

        }
    }
    .about-us {
        padding: 0 4rem;
        h3, .section h3, .rev-section h3 {
            width: 100%; place-items: center; font-size: 3em; color: rgb(24, 33, 109); font-weight: 500; display: flex; flex-direction: column;
        }
        .section p, .rev-section p {
            width: 100%; place-items: center; font-size: 1.5em; color: rgb(24, 33, 109); font-weight: 500; display: flex; flex-direction: column;
            word-break: break-word;
        }
        img {
            width: 100%;
            min-width: 480px;
        }
        .section {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 1rem;
        }
        .rev-section {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: center;
            gap: 1rem;
        }
        @media only screen and (max-width: 890px) {
            .section {
                flex-direction: column;
            }
            .rev-section {
                flex-direction: column;
            }
        }
    }
    .ant-card-actions {
        border-top: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        li span {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;
        }
    }
    .ant-card-body {
        padding: 0.5rem 1rem;
        font-size: 1.5em;
        color: rgb(24, 33, 109);
    }
    .visualise {
        gap: 1rem;
        .section {
            justify-content: space-around !important;
            img {
                width: 100%;
                min-width: 480px;
                max-width: 640px;
            }
            margin-bottom: 3rem;
        }
        .rev-section {
            justify-content: space-around !important;
            img {
                width: 100%;
                min-width: 480px;
                max-width: 640px;
            }
                margin-bottom: 3rem;
        }
    }
`;
